import Page00 from '../../../../Book/EbookEtape_1/Pages/00';
import Page01 from '../../../../Book/EbookEtape_1/Pages/01';
import Page02 from '../../../../Book/EbookEtape_1/Pages/02';
import Page03 from '../../../../Book/EbookEtape_1/Pages/03';
import Page04 from '../../../../Book/EbookEtape_1/Pages/04';
import Page05 from '../../../../Book/EbookEtape_1/Pages/05';
import Page06 from '../../../../Book/EbookEtape_1/Pages/06';
import Page07 from '../../../../Book/EbookEtape_1/Pages/07';
import Page08 from '../../../../Book/EbookEtape_1/Pages/08';
import Page09 from '../../../../Book/EbookEtape_1/Pages/09';
import Page10 from '../../../../Book/EbookEtape_1/Pages/10';
import Page11 from '../../../../Book/EbookEtape_1/Pages/11';
import Page12 from '../../../../Book/EbookEtape_1/Pages/12';
import Page13 from '../../../../Book/EbookEtape_1/Pages/13';
import Page14 from '../../../../Book/EbookEtape_1/Pages/14';
import Page15 from '../../../../Book/EbookEtape_1/Pages/15';
import Page16 from '../../../../Book/EbookEtape_1/Pages/16';
import Page17 from '../../../../Book/EbookEtape_1/Pages/17';
import Page18 from '../../../../Book/EbookEtape_1/Pages/18';
import Page19 from '../../../../Book/EbookEtape_1/Pages/19';
import Page20 from '../../../../Book/EbookEtape_1/Pages/20';
import Page21 from '../../../../Book/EbookEtape_1/Pages/21';
import Page22 from '../../../../Book/EbookEtape_1/Pages/22';
import Page23 from '../../../../Book/EbookEtape_1/Pages/23';
import Page24 from '../../../../Book/EbookEtape_1/Pages/24';
import Page25 from '../../../../Book/EbookEtape_1/Pages/25';
import Page26 from '../../../../Book/EbookEtape_1/Pages/26';
import Page27 from '../../../../Book/EbookEtape_1/Pages/27';
import Page28 from '../../../../Book/EbookEtape_1/Pages/28';
import Page29 from '../../../../Book/EbookEtape_1/Pages/29';
import Page30 from '../../../../Book/EbookEtape_1/Pages/30';
import Page31 from '../../../../Book/EbookEtape_1/Pages/31';
import Page32 from '../../../../Book/EbookEtape_1/Pages/32';
import Page33 from '../../../../Book/EbookEtape_1/Pages/33';
import Page34 from '../../../../Book/EbookEtape_1/Pages/34';
import Page36 from '../../../../Book/EbookEtape_1/Pages/36';
import Page37 from '../../../../Book/EbookEtape_1/Pages/37';
import Page38 from '../../../../Book/EbookEtape_1/Pages/38';
import Page39 from '../../../../Book/EbookEtape_1/Pages/39';
import Page40 from '../../../../Book/EbookEtape_1/Pages/40';
import Page41 from '../../../../Book/EbookEtape_1/Pages/41';
import Page42 from '../../../../Book/EbookEtape_1/Pages/42';

type StepContentProps = {
  readOnly: boolean;
};

const Step1Content = ({ readOnly }: StepContentProps) => (
  <>
    <Page00 />
    <Page01 />
    <Page02 />
    <Page03 />
    <Page04 readOnly={readOnly} />
    <Page05 />
    <Page06 />
    <Page07 />
    <Page08 />
    <Page09 />
    <Page10 />
    <Page11 />
    <Page12 />
    <Page13 />
    <Page14 readOnly={readOnly} />
    <Page15 readOnly={readOnly} />
    <Page16 readOnly={readOnly} />
    <Page17 readOnly={readOnly} />
    <Page18 readOnly={readOnly} />
    <Page19 />
    <Page20 />
    <Page21 />
    <Page22 />
    <Page23 />
    <Page24 />
    <Page25 />
    <Page26 readOnly={readOnly} />
    <Page27 />
    <Page28 />
    <Page29 readOnly={readOnly} />
    <Page30 />
    <Page31 />
    <Page32 />
    <Page33 />
    <Page34 readOnly={readOnly} />
    <Page36 />
    <Page37 />
    <Page38 />
    <Page39 />
    <Page40 />
    <Page41 readOnly={readOnly} />
    <Page42 />
  </>
);

export default Step1Content;
